'use strict';

exports.__esModule = true;
exports.getSpecialtyIconUri = exports.specialtyMapping = undefined;

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var specialtyMapping = exports.specialtyMapping = function specialtyMapping() {
  var specialtiesDictionary = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var specialtyName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  for (var _iterator = specialtiesDictionary, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var specialty = _ref;

    if (specialty.name === specialtyName) {
      return specialty;
    }
  }

  return null;
};

var getSpecialtyIconUri = exports.getSpecialtyIconUri = function getSpecialtyIconUri() {
  var specialtiesDictionary = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var specialtyName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var specialty = specialtyMapping(specialtiesDictionary, specialtyName);

  return specialty && 'https://vitality.doctify.co.uk' + specialty.icon_uri;
};


// WEBPACK FOOTER //
// ./components/search-results/lib/utils/utils.js